<template>
  <section>
    <div
      class="tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:pt-6 tw:md:pt-9 tw:lg:pt-8 tw:mx-auto tw:grid tw:grid-cols-1 tw:md:grid-cols-[50%_50%] tw:gap-y-8 tw:md:gap-8 tw:lg:gap-12 tw:items-center"
    >
      <div class="tw:flex tw:flex-col tw:w-full tw:items-center tw:md:items-start">
        <h1
          class="tw:font-bold tw:mb-2 tw:md:mb-4 tw:md:text-left tw:text-center tw:lg:text-header-big tw:md:text-medium tw:text-medium"
          v-html="$t('studio_plus_mp_header')"
        />
        <p class="tw:text-xs tw:md:text-sm tw:lg:text-lg tw:md:text-left tw:text-center">
          {{ $t('plus_product_page_subtext') }}
        </p>
        <MainButton @click="onLoginClick" class="tw:lg:flex tw:hidden tw:mt-10">{{
          $t('business_studio_plus_cta')
        }}</MainButton>
        <MainButton @click="onLoginClick" size="medium" class="tw:flex tw:lg:hidden tw:mt-4">{{
          $t('business_studio_plus_cta')
        }}</MainButton>
      </div>
      <div class="tw:flex tw:items-center tw:justify-center tw:md:justify-end tw:w-full">
        <StudioPlusHeroVideo class="tw:w-full tw:h-auto tw:max-w-[320px] tw:md:max-w-none tw:md:h-[250px] tw:lg:h-[413px] tw:block" />
      </div>
    </div>
  </section>
</template>
<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import StudioPlusHeroVideo from '@/components/studioPlus/StudioPlusHeroVideo.vue'

import appAnalytics from '@/utils/tracking'

const emit = defineEmits(['onLoginClick'])
const onLoginClick = e => {
  appAnalytics.track(appAnalytics.events.SP_START_SUBSCRIPTION_LANDING_CLICKED)
  emit('onLoginClick', e.target.value)
}
</script>
